const FIELD_TYPES = ['data-validation', 'inputMode', 'type'];

export const validatePassword = (value, context) => {

    return new Promise((resolve, reject) => {
        let success = true;
        let chars = context.querySelector('.form-notification__count span');
        let numeric = context.querySelector('.form-notification__numeric span');
        let uppercase = context.querySelector('.form-notification__uppercase span');
        let lowercase = context.querySelector('.form-notification__lowercase span');
        let special = context.querySelector('.form-notification__special span');

        // password is 8 or more chars
        if (/(?=.{8,})/.test(value)) {

            chars.innerHTML = '&#10004;';
            chars.classList.add('highlight');
        } else {
            chars.innerHTML = '&#8226;';
            chars.classList.remove('highlight');
        }

        // Password contains a number
        if (/(?=.*[0-9])/.test(value)) {
            numeric.innerHTML = '&#10004;';
            numeric.classList.add('highlight');
        } else {
            numeric.innerHTML = '&#8226;';
            numeric.classList.remove('highlight');
        }
        // Password contains a uppercase letter
        if (/(?=.*[A-Z])/.test(value)) {
            uppercase.innerHTML = '&#10004;';
            uppercase.classList.add('highlight');
        } else {
            uppercase.innerHTML = '&#8226;';
            uppercase.classList.remove('highlight');
        }

        // Password contains a lowercase letter
        if (/(?=.*[a-z])/.test(value)) {
            lowercase.innerHTML = '&#10004;';
            lowercase.classList.add('highlight');
        } else {
            lowercase.innerHTML = '&#8226;';
            lowercase.classList.remove('highlight');
        }

        // Password contains a special chars
        if (/(?=.*[!@#$%^&*?_~-£])/.test(value)) {
            special.innerHTML = '&#10004;';
            special.classList.add('highlight');
        } else {
            special.innerHTML = '&#8226;';
            special.classList.remove('highlight');
        }

        success ? resolve() : reject();
    }) as Promise<void>;
};

export const validateForm = (context) => {
    return new Promise((resolve, reject) => {
        const fields = getFields(context);
        const customSelects = getCustomSelectFields(context);
        let success = true;

        fields.forEach((field) => {
            const inputFieldContainer = getInputFieldContainer(field);
            resetInputField(inputFieldContainer);

            if (!isFieldValid(field)) {
                success = false;
                handleInvalidField(inputFieldContainer);
            }
        });

        customSelects.forEach((customSelect) => {
            const inputFieldContainer =
                getCustomSelectFieldContainer(customSelect);
            resetInputField(inputFieldContainer);

            if (!isFieldValidCustomSelect(customSelect)) {
                success = false;
                handleInvalidField(inputFieldContainer);
            }
        });

        success ? resolve() : reject();
    }) as Promise<void>;
};

const checkTelephone = (fieldValue) =>
    /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/.test(fieldValue)
        ? true
        : false;

function checkEmail(fieldValue) {
    return fieldValue.indexOf('@') !== -1 && fieldValue.indexOf('.') !== -1
        ? true
        : false;
}

const getFields = (context) =>
    context.querySelectorAll('input:not([type="hidden"])');

const getCustomSelectFields = (context) =>
    context.querySelectorAll('.custom-select.is-required input');

const getInputFieldContainer = (element) =>
    element.closest('.input-group') ? element.closest('.input-group') : element;

const getCustomSelectFieldContainer = (element) =>
    element.closest('.custom-select.is-required')
        ? element.closest('.custom-select')
        : element;

const handleInvalidField = (inputGroup) => {
    if (inputGroup) inputGroup.classList.add('is-invalid');
};

const resetInputField = (inputGroup) => {
    if (inputGroup) inputGroup.classList.remove('is-invalid');
};

const isFieldValid = (field) => {
    const validationType = getFieldValidationType(field);
    const isRequired = field.getAttribute('required') === 'required';
    const fieldValue = field.value;

    if (isRequired && fieldValue.length === 0) return false;
    if (validationType === 'text') return true;

    try {
        return FIELD_VALIDATION_METHODS[validationType](fieldValue);
    } catch (e) {
        console.log(e);
        return true;
    }
};

const isFieldValidCustomSelect = (field) => {
    const fieldValue = field.value;
    const validationType = getFieldValidationType(field);

    if (fieldValue.length === 0) return false;
    if (validationType === 'text') return true;

    try {
        return FIELD_VALIDATION_METHODS[validationType](fieldValue);
    } catch (e) {
        console.log(e);
        return true;
    }
};

const getFieldValidationType = (field) => {
    let returnType;

    for (let type of FIELD_TYPES) {
        if (field.hasAttribute(type)) {
            returnType = field.getAttribute(type);
        }
    }

    return returnType;
};
const FIELD_VALIDATION_METHODS = {
    tel: checkTelephone,
    email: checkEmail
};
